<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="roomTypeAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="name" class="form-label">Holder name:</label>
                    <input id="name" class="form-control" name="holder_name" v-model="formData.holder_name" :class="checkValidation(classes)" placeholder="holder name" type="text">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="number" class="form-label">Number:</label>
                    <input id="number" class="form-control" name="holder_name" v-model="formData.number" :class="checkValidation(classes)" placeholder="number" type="number">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="exp_month" class="form-label">Exp month:</label>
                    <input id="exp_month" class="form-control" name="exp_month" v-model="formData.exp_month" :class="checkValidation(classes)" max="12" placeholder="exp month" type="number">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="exp_year" class="form-label">Exp year:</label>
                    <input id="exp_year" class="form-control" name="exp_year" v-model="formData.exp_year" :class="checkValidation(classes)"  placeholder="exp year" type="number">
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="svc" class="form-label">Svc:</label>
                    <input id="svc" class="form-control" name="svc" v-model="formData.svc" :class="checkValidation(classes)" placeholder="svc" maxlength="3" type="number">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="types_id" class="form-label">Types:</label>
                    <select class="form-control" :class="checkValidation(classes)" name="" v-model="formData.type" id="types_id">
                      <option :value="key" v-for="(it, key) in types" :key="key">{{it}}</option>
                    </select>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'creditCard'
const url = 'credit-card'
export default {
  name: 'CityAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      types: [],
      formData: {
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    }
    this.getCreateData().then((res) => {
      this.types = res.types
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    checkValidation (data) {
      return data
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + this.url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + this.url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
